export default __webpack_public_path__ + "static/media/residency visa research.c104f855.jpg";